import { IApplicationState } from '../../types/redux';

export function selectPageType(state: IApplicationState) {
  return state.pageType;
}
